import { defineStyleConfig, } from '@chakra-ui/styled-system';
import { ThemeBorderVariable, ThemeColorVariable } from '../../theme-types';
const baseStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    border: `${ThemeBorderVariable.XSmall} transparent`,
    '&[aria-disabled="true"]': {
        borderColor: 'transparent',
        backgroundColor: ThemeColorVariable.SurfaceDisabled,
        cursor: 'not-allowed',
    },
    '&[aria-readonly="true"]': {
        borderColor: 'transparent',
        backgroundColor: ThemeColorVariable.SurfaceDisabled,
    },
};
const variants = {
    outline: {
        background: ThemeColorVariable.Surface,
        color: ThemeColorVariable.OnSurface,
        borderColor: ThemeColorVariable.OnSurfaceBorder,
        '@media(hover: hover)': {
            '&:hover:not(:focus-within):not([aria-disabled="true"]):not([aria-readonly="true"])': {
                borderColor: ThemeColorVariable.OnSurface,
            },
        },
    },
    ghost: {
        background: 'none',
        color: ThemeColorVariable.OnSurface,
        '&:not([aria-disabled="true"]):not([aria-readonly="true"]) .combobox-dropdown-icon': {
            opacity: 0,
        },
        ':focus-within': {
            '.combobox-dropdown-icon': {
                opacity: 1,
            },
        },
        '@media(hover: hover)': {
            '&:hover:not(:focus-within)': {
                backgroundColor: ThemeColorVariable.SurfaceDisabled,
                '.combobox-dropdown-icon': {
                    opacity: 1,
                },
            },
        },
    },
};
const sizes = {
    xs: {
        minHeight: '24px',
    },
    sm: {
        minHeight: '32px',
    },
    md: {
        minHeight: '40px',
    },
    lg: {
        minHeight: '48px',
    },
    xl: {
        minHeight: '56px',
    },
};
export const comboboxConfig = defineStyleConfig({
    baseStyle,
    sizes,
    variants,
});
//# sourceMappingURL=combobox-theme.js.map